/**
 * BRAND_DIRECTORY — curated list of well-known companies the admin can
 * one-tap to re-theme the TMS. Grouped by industry for easy scanning.
 *
 * Each entry only needs a name + emoji/icon hint; the backend will use
 * Claude Sonnet to fill in the actual colors, products, suppliers and lanes.
 */
export const BRAND_DIRECTORY = [
  { name: "FedEx",            industry: "Logistics" },
  { name: "UPS",              industry: "Logistics" },
  { name: "DHL",              industry: "Logistics" },
  { name: "USPS",             industry: "Logistics" },
  { name: "C.H. Robinson",    industry: "Logistics" },
  { name: "XPO Logistics",    industry: "Logistics" },
  { name: "J.B. Hunt",        industry: "Logistics" },
  { name: "Schneider National", industry: "Logistics" },
  { name: "Walmart",          industry: "Retail" },
  { name: "Target",           industry: "Retail" },
  { name: "Costco",           industry: "Retail" },
  { name: "Home Depot",       industry: "Retail" },
  { name: "Lowe's",           industry: "Retail" },
  { name: "Best Buy",         industry: "Retail" },
  { name: "Macy's",           industry: "Retail" },
  { name: "Amazon",           industry: "Ecommerce" },
  { name: "eBay",             industry: "Ecommerce" },
  { name: "Shopify",          industry: "Ecommerce" },
  { name: "Wayfair",          industry: "Ecommerce" },
  { name: "Apple",            industry: "Technology" },
  { name: "Microsoft",        industry: "Technology" },
  { name: "Google",           industry: "Technology" },
  { name: "Meta",             industry: "Technology" },
  { name: "Samsung",          industry: "Technology" },
  { name: "Sony",             industry: "Technology" },
  { name: "Dell",             industry: "Technology" },
  { name: "HP",               industry: "Technology" },
  { name: "Tesla",            industry: "Automotive" },
  { name: "Ford",             industry: "Automotive" },
  { name: "General Motors",   industry: "Automotive" },
  { name: "Toyota",           industry: "Automotive" },
  { name: "Honda",            industry: "Automotive" },
  { name: "Stellantis",       industry: "Automotive" },
  { name: "Caterpillar",      industry: "Industrial" },
  { name: "John Deere",       industry: "Industrial" },
  { name: "3M",               industry: "Industrial" },
  { name: "Honeywell",        industry: "Industrial" },
  { name: "Bosch",            industry: "Industrial" },
  { name: "Siemens",          industry: "Industrial" },
  { name: "GE",               industry: "Industrial" },
  { name: "Boeing",           industry: "Aerospace" },
  { name: "Lockheed Martin",  industry: "Aerospace" },
  { name: "Raytheon",         industry: "Aerospace" },
  { name: "Northrop Grumman", industry: "Aerospace" },
  { name: "Coca-Cola",        industry: "F&B" },
  { name: "PepsiCo",          industry: "F&B" },
  { name: "Nestlé",           industry: "F&B" },
  { name: "Kraft Heinz",      industry: "F&B" },
  { name: "Tyson Foods",      industry: "F&B" },
  { name: "Kellogg's",        industry: "F&B" },
  { name: "Starbucks",        industry: "F&B" },
  { name: "McDonald's",       industry: "F&B" },
  { name: "Procter & Gamble", industry: "CPG" },
  { name: "Unilever",         industry: "CPG" },
  { name: "Colgate-Palmolive", industry: "CPG" },
  { name: "Kimberly-Clark",   industry: "CPG" },
  { name: "Nike",             industry: "Apparel" },
  { name: "Adidas",           industry: "Apparel" },
  { name: "Levi's",           industry: "Apparel" },
  { name: "Under Armour",     industry: "Apparel" },
  { name: "Lululemon",        industry: "Apparel" },
  { name: "Pfizer",           industry: "Pharma" },
  { name: "Johnson & Johnson", industry: "Pharma" },
  { name: "Merck",            industry: "Pharma" },
  { name: "Eli Lilly",        industry: "Pharma" },
  { name: "AbbVie",           industry: "Pharma" },
  { name: "ExxonMobil",       industry: "Energy" },
  { name: "Chevron",          industry: "Energy" },
  { name: "Shell",            industry: "Energy" },
  { name: "BP",               industry: "Energy" },
  { name: "ConocoPhillips",   industry: "Energy" },
  { name: "Pfizer",           industry: "Pharma" },
  { name: "Maersk",           industry: "Shipping" },
  { name: "MSC",              industry: "Shipping" },
  { name: "CMA CGM",          industry: "Shipping" },
  { name: "Hapag-Lloyd",      industry: "Shipping" },
  { name: "ONE",              industry: "Shipping" },
  { name: "Orisei Freight Solutions",  industry: "Industrial" },
];

export const INDUSTRIES = [...new Set(BRAND_DIRECTORY.map((b) => b.industry))].sort();
